<svg [attr.height]="height()" [attr.width]="width()" fill="#fefefe"
     stroke="#FEFEFE"
     style="overflow: visible"
     viewBox="0 0 640 640"
     xmlns="http://www.w3.org/2000/svg">

    <g stroke-width="0"
       transform="translate(32,32), scale(0.70)">
        <rect [attr.fill]="backgroundColor()"
              height="800"
              rx="400"
              strokewidth="0"
              width="800"
              x="0"
              y="0"/>
    </g>

    <g stroke-linecap="round" stroke-linejoin="round"/>
    <g>
        <path d="M319.184 312.2166l74.1008-74.3998L276.5 125v148.5576l-68.8888-61.9999-25.1248 22.6116 86.4488 78.0473L182.4864 390.2638l25.1248 22.6116 68.8888-61.9999L278.672 493.64l118.8416-107.0237-78.3296-74.3998zm32.688-74.1571-39.9816 35.9842-.2704-72.2124 40.252 36.2282zM311.8904 350.3888l39.9816 35.9842-40.252 36.2275.2704-72.2117z"/>
    </g>
</svg>